import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import custPopover from '@/components/cust_components/cust_popover_component.vue';
import Vue from 'vue';
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)

export default {
    name: 'serviceComp',
    components:{
        headerComponent,
        FooterComponent,
        LoaderPopover,
        custPopover
    },
    data(){
        return {
            service_details : '',
            mobile_view : false,
            added_to_cart : false,
            block_customer_popup : false,
            session_service_details : [],
            session_product_details : [],
            popup_mobile : this.$session.get('store_details') ? JSON.parse(this.$session.get('store_details')).store_mobile : '',
            href_text :  window.location.href,
            serv_decrypt_code : {},
            store_details : {},
        }
    },
    mounted(){
        let last_path = window.location.href;
        last_path = last_path.substr(last_path.indexOf('/service'),last_path.length);
        last_path = last_path.split('/');

        let serv_encrypt_code = last_path[2].replace(/xMl3Jk/g, '+' ).replace(/Por21Ld/g, '/').replace(/Ml32/g, '=');

        this.serv_decrypt_code = this.CryptoJS.AES.decrypt(serv_encrypt_code,this.Constants.CRYPTO_KEY);
        this.serv_decrypt_code = this.serv_decrypt_code.toString(this.CryptoJS.enc.Utf8);
        if(this.serv_decrypt_code){
            this.serv_decrypt_code = JSON.parse(this.serv_decrypt_code);
            if(!this.$session.get('store_details') || (JSON.parse(this.$session.get('store_details'))['store_id'] != this.serv_decrypt_code.store_id) ){
                this.getStoreDetails();
            }            
            this.$store.commit('storeUrlName', this.serv_decrypt_code.store_name);
            this.getStoreCategories();
        }else{
            this.service_details = null;
        }
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);

        if(this.$session.get('service_obj')){
            this.session_service_details = JSON.parse(this.$session.get('service_obj'));
            this.session_service_details.forEach((session_serv) => {
                if(session_serv.serv_id == this.serv_decrypt_code.serv_id){
                    this.added_to_cart = true;
                }
            })
        }
        this.$store.state.total_services_in_cart = this.session_service_details.length;

        if(this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0){
            this.session_product_details = JSON.parse(this.$session.get('product_obj'));
            this.$store.state.total_products_in_cart = this.session_product_details.length;
        }else{
            this.$store.state.total_products_in_cart = 0;
        }
    },
    methods:{
        async getStoreDetails(){
            await this.$store.dispatch('getStoreDetails',[this.$store.state.api,this.serv_decrypt_code.store_name])
            let storedetails_array = this.$store.state.cust_store_data;
            this.store_details = JSON.stringify({
                store_id        :  storedetails_array.store_id,
                store_name      :  storedetails_array.store_url_name,
                store_mobile    :  storedetails_array.store_tel,
                store_publish_key   :  storedetails_array.store_api_publish_key,
            });
            this.$session.set('store_details',  this.store_details);

            this.popup_mobile = storedetails_array.store_tel;
        },
        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth);
        },
        async getStoreCategories(){
            this.$store.state.loader_popup = true;
            await this.$store.dispatch('getStoreCategories',[this.$store.state.api,this.serv_decrypt_code.store_id]);
//            this.$ga.page(this.$router);
            if(Object.keys(this.$store.state.store_categories).length > 0){
                let categories = this.$store.state.store_categories;
                categories.forEach((category)=>{
                    if(category.serv_cat_id == this.serv_decrypt_code.serv_cat_id){
                        let services = category.services;
                        services.forEach((service)=>{
                            if(service.serv_id == this.serv_decrypt_code.serv_id){
                                this.service_details = service;
                                if(this.service_details.serv_image1){
                                    this.service_details.serv_image1 = this.service_details.serv_image1.split(',');
                                    console.log(this.service_details.serv_image1);
                                    this.service_details.serv_image1 = this.service_details.serv_image1[0];
                                    console.log(this.service_details.serv_image1);
                                }
                            }
                        })
                    }
                })
            }
            if(this.service_details == ''){
                this.service_details = null;
            }
            this.$store.state.loader_popup = false;

        },
        categories_redirect()
        {
            this.$router.push('/home/'+ this.$store.state.store_url_name);
        },
        add_cart_toggle(){
            if(this.added_to_cart){
                this.check_Banned();
            }else{
                if(this.$session.get('cust_details')){
                    if(this.$session.get('cust_banned_data')){
                        if(JSON.parse(this.$session.get('cust_banned_data')).cust_banned == 0){
                            this.added_to_cart = true;
                            this.addServices(); 
                        }
                        else{
                            this.block_customer_popup = true;   
                        }
                    }else{
                        this.added_to_cart = true;
                        this.addServices();
                    }  
                }else{
                    this.added_to_cart = true;
                    this.addServices();
                } 
               
            }  
            
        },
        redirect_to_cart(){
            this.$router.push('/cart');
        },
        check_Banned(){
            if(this.$session.get('cust_details')){
                if(this.$session.get('cust_banned_data')){
                    if(JSON.parse(this.$session.get('cust_banned_data')).cust_banned == 0){
                        this.$router.push('/cart');  
                    }
                    else{
                        this.block_customer_popup = true;   
                    }
                }else{
                    this.$router.push('/cart');
                }  
            }else{
                this.$router.push('/cart');
            } 
        },
        close_block_customer_popup(){
            this.block_customer_popup = false;
            if(this.$session.get('service_obj'))
            {
                this.$session.remove('service_obj');
                this.$session.remove('product_obj');
                this.$session.remove('store_details');
                this.$router.push('/mybookings');
            }
           
        },
        addServices(){
            let serv_obj = [];

            if(this.$session.get('service_obj')){
                serv_obj = JSON.parse(this.$session.get('service_obj')) ;
            }
            
            serv_obj.push(this.service_details)
            this.$session.set('service_obj', JSON.stringify(serv_obj));
            this.$store.state.total_services_in_cart = serv_obj.length;
            this.$router.push('/cart');  
            
        },

        copy_link(){
            let copy_text = this.$refs.share_text;
            copy_text.style.display = "block";

            var editable = copy_text.contentEditable;
            var readOnly = copy_text.readOnly;

            // convert to editable with readonly to stop iOS keyboard opening
            copy_text.contentEditable = true;
            copy_text.readOnly = true;

            // create a selectable range
            var range = document.createRange();
            range.selectNodeContents(copy_text);

            // // select the range
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            copy_text.setSelectionRange(0, 999999);

            // restore contentEditable/readOnly to original state
            copy_text.contentEditable = editable;
            copy_text.readOnly = readOnly;

            copy_text.select();
            document.execCommand("copy");
            let title = 'Successful';
            let message = "Link copied successfully"
            this.$bvToast.toast(`${message}`, {
                title: `${title}`,
                variant: 'success',
                autoHideDelay: 5500,
                solid: true
            })

            copy_text.style.display = "none";
        },
        getImgUrl($event){
            $event.target.src = require('@/assets/customer/images/default_service.svg');
        }
    }
}